<template>
  <div class="juzhuanhu">
    <!-- 头部 -->
    <!-- <Header /> -->
    <!-- banner -->
    <div class="tops">
      <img src="../../../assets/images/juzhuanhu/banner.png" alt="百才汇" />
    </div>
    <!-- 居转户条件 -->
    <div class="tiaojian">
      <div class="biaotou">
        <ul>
          <li class="li1">
            <img
              src="../../../assets/images/juzhuanhu/right.png"
              alt="百才汇"
            />
          </li>
          <li class="li2"><p>上海居转户，需要满足哪些条件</p></li>
          <li class="li1">
            <img src="../../../assets/images/juzhuanhu/left.png" alt="百才汇" />
          </li>
        </ul>
      </div>
      <div class="yaoqiu">
        <ul>
          <li class="li1">
            <div class="biao">
              <p>基本要求</p>
            </div>
            <p class="p1">1、持有《上海市居住证》满7年</p>
            <p class="p1">2、持证期间社保满7年</p>
            <p class="p1">3、持证期间依法在本市纳税</p>
            <p class="p1">4、符合国家及本市现行计划生育政策</p>
            <p class="p1">5、持有对应的中级职称</p>
          </li>
          <li class="li2">
            <div class="biao">
              <p>奖励要求</p>
            </div>
            <p class="p1">1、本市做出重大贡献并取得个人证书</p>
            <p class="p1">
              2、本市聘为高级专业技术职务或者本市聘为高级技师,所从事工作与技能一致
            </p>
            <p class="p1">3、上面两个满足其一，可直接申报落户</p>
          </li>
        </ul>
        <ul>
          <li class="li1">
            <div class="biao">
              <p>投资要求</p>
            </div>
            <p class="p1">1、连续3个纳税年度平均每年税额在100万元及以上</p>
            <p class="p1">2、连续3年平均每年聘用本市员工100人及以上</p>
            <p class="p1">3、员工必须缴纳社保和个税</p>
          </li>
          <li class="li2">
            <div class="biao">
              <p>其他要求</p>
            </div>
            <p class="p1">1、在本市远郊从事教育、卫生岗位满5年，参保缩为3年</p>
            <p class="p1">2、最近连续3年缴纳社保基数高于职工平均工资2倍以上</p>
            <p class="p1">3、最近连续3年计税薪酬收入高于去年同行业收入水平</p>
          </li>
        </ul>
      </div>
    </div>
    <!-- 落户资讯服务 -->
    <div class="fuwu">
      <div class="biaotou">
        <ul>
          <li class="li1">
            <img
              src="../../../assets/images/juzhuanhu/right.png"
              alt="百才汇"
            />
          </li>
          <li class="li2"><p>百才汇专业居转户落户咨询服务有哪些？</p></li>
          <li class="li1">
            <img src="../../../assets/images/juzhuanhu/left.png" alt="百才汇" />
          </li>
        </ul>
      </div>
      <div class="xiangxi">
        <ul>
          <li class="li1">
            <p class="p1">政策解答</p>
            <p class="p2">
              多年专注上海居转户政策咨询，提供上海居转户政策免费咨询！
            </p>
          </li>
          <li class="li2">
            <p class="p1">疑难处理</p>
            <p class="p2">
              为上海居转户提供落户过程中遇到的各种疑难处理和咨询，拥有资深人脉可以协助客户处理各种疑难；
            </p>
          </li>
        </ul>
        <ul>
          <li class="li3">
            <p class="p1">材料咨询</p>
            <p class="p2">
              上海居转户申请材料多，且准备较繁琐，如不清楚可以免费咨询百才汇专业老师；
            </p>
          </li>
          <li class="li4">
            <p class="p1">税和社保不匹配</p>
            <p class="p2">
              上海居转户需要税和社保匹配，如果出现社保和个税缴纳时间不匹配，税和社保少交或者漏缴等问题请向百才汇专业老师寻求免费咨询；
            </p>
          </li>
        </ul>
        <ul>
          <li class="li5">
            <p class="p1">重复报税</p>
            <p class="p2">
              在职期间，两家及其以上的公司同时在给其申报个税，包括异地有社保和个税等问题请免费咨询百才汇专业老师；
            </p>
          </li>
          <li class="li6">
            <p class="p1">不熟悉办理流程</p>
            <p class="p2">
              上海居转户手续繁琐且材料准备复杂，很多申请人在准备过程中，往往觉得很迷茫，如有相关疑难请咨询百才汇专业老师。
            </p>
          </li>
        </ul>
      </div>
    </div>
    <!-- 服务流程 -->
    <div class="liucheng">
      <div class="buzhou">
        <div class="ldian"></div>
        <div class="xiangxi">
          <ul>
            <li>
              <p class="p1">前期在线沟通</p>
              <p class="p2">· 客户填写基础信息（关注公众号领取免费咨询券）</p>
              <p class="p2">· 落户专家给予初步反馈</p>
            </li>
            <li style="margin-top: 8px">
              <p class="p1">办公室面签</p>
              <p class="p2">· 办公室面签</p>
              <p class="p2">· 规划落户流程、时间节点、注意事项等</p>
              <p class="p2">· 现场合同讲解、签约</p>
            </li>
            <li style="margin-top: 8px">
              <p class="p1">签约后初期</p>
              <p class="p2">· 客户背景情况调整、如有瑕疵点进行补足</p>
              <p class="p2">· 完成递交所需的材料</p>
            </li>
            <li style="margin-top: 8px">
              <p class="p1">签约后中期</p>
              <p class="p2">· 区人才服务中心递交材料</p>
              <p class="p2">· 区级、市级审批、落户公示</p>
            </li>
            <li style="margin-top: 8px">
              <p class="p1">签约后后期</p>
              <p class="p2">· 拿到落户通知书、公安局准迁证</p>
              <p class="p2">· 到原户籍地开迁移证、调档</p>
              <p class="p2">· 派出所落户</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 联系我们 -->
    <div class="biaodan">
      <div class="kongbai"></div>
      <div class="tu">
        <img src="../../../assets/images/juzhuanhu/bottom.png" alt="百才汇" />
      </div>
      <div class="biao">
        <div class="biaoge">
          <div class="line">
            <ul>
              <li class="li1">
                <img
                  src="../../../assets/images/juzhuanhu/right.png"
                  alt="百才汇"
                />
              </li>
              <li class="li2"><p>联系我们</p></li>
              <li class="li1">
                <img
                  src="../../../assets/images/juzhuanhu/left.png"
                  alt="百才汇"
                />
              </li>
            </ul>
          </div>
          <div class="inputis">
            <p>你的姓名</p>
            <input
              class="inpis"
              v-model="username"
              type="text"
              placeholder="请输入你的姓名 "
            />
            <p>联系电话</p>
            <input
              class="inpis"
              v-model="tel"
              type="text"
              placeholder="请输入你的联系电话"
            />
            <button class="btnis" @click="registerOne">提交</button>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <Bottom />
  </div>
</template>

<script>
import Vue from "vue";
import { Notify } from "vant";
import Header from "@/P09_BaiCaiHui/components/Header.vue";
import Bottom from "@/P09_BaiCaiHui/components/Foot.vue";
export default {
  components: {
    Header,
    Bottom,
  },
  metaInfo() {
    return {
      title: "居转户【条件_申请_新政策】-百才汇",
      meta: [
        {
          name: "keywords",
          content: "居转户,居转户条件,居转户申请,居转户新政策",
        },
        {
          name: "description",
          content:
            "居转户就找百才汇，1对1咨询定制居转户方案，专业靠谱的落户团队，拥有大量的成功案例，并为您解读居转户,居转户条件,居转户申请,居转户新政策等信息！  ",
        },
      ],
    };
  },
  data() {
    return {
      username: "",
      tel: "",
    };
  },
  methods: {
    registerOne() {
      if (!this.username) {
        Notify({ type: "danger", message: "请输入您的姓名" });
        this.username = "";
        return false;
      }
      if (!this.tel) {
        Notify({ type: "danger", message: "请输入正确手机号码" });
        this.tel = "";
        return false;
      }
      this.$axios
        .post("/trip/InfoSources/WebRegister", {
          C01_Name: this.username, //姓名
          C01_Tel: this.tel, //联系方式
          C01_Origin: 193, //信息来源
        })
        .then((res) => {
          if (res.data.Message == "success") {
            this.$message.success("报名成功!");
            this.username = "";
            this.tel = "";
          } else if (res.data.Code == 400) {
            Notify({ type: "success", message: res.data.Message });
          } else {
            Notify({ type: "success", message: res.data.Message });
          }
        });
    },
  },
};
</script>

<style lang="scss" scope>
.juzhuanhu {
  .tops {
    margin-top: 70px;
    width: 100%;
    height: 400px;
    img {
      width: 100%;
      height: 400px;
    }
  }
  .tiaojian {
    width: 670px;
    margin: auto;
    margin-top: 55px;
    .biaotou {
      ul {
        width: 540px;
        display: flex;
        margin: auto;
        .li1 {
          width: 37px;
          height: 28px;
          margin-top: 5px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .li2 {
          margin: 0px 10px;
          p {
            font-size: 30px;
            font-weight: bold;
            color: #333333;
          }
        }
      }
    }
    .yaoqiu {
      ul {
        margin-top: 40px;
        display: flex;
        .li1 {
          width: 315px;
          height: 356px;
          background: url("../../../assets/images/juzhuanhu/left-bj.png")
            no-repeat center/cover;
          margin-right: 40px;
          border-radius: 10px 10px 2px 10px;
          position: relative;
          padding-top: 80px;
          box-sizing: border-box;
          .biao {
            position: absolute;
            left: 0;
            top: 0;
            width: 166px;
            height: 40px;
            p {
              font-size: 24px;
              line-height: 45px;
              font-family: yixinchangyouti;
              font-weight: 400;
              color: #ffffff;
              text-align: center;
            }
          }
          .p1 {
            font-size: 20px;
            font-weight: 400;
            color: #333333;
            width: 278px;
            margin: auto;
            line-height: 36px;
          }
        }
        .li2 {
          width: 315px;
          height: 356px;
          background: url("../../../assets/images/juzhuanhu/right-bj.png")
            no-repeat center/cover;
          position: relative;
          padding-top: 80px;
          box-sizing: border-box;
          .biao {
            position: absolute;
            right: 0;
            top: 0;
            width: 166px;
            height: 40px;
            p {
              font-size: 24px;
              line-height: 45px;
              font-family: yixinchangyouti;
              font-weight: 400;
              color: #ffffff;
              text-align: center;
            }
          }
          .p1 {
            font-size: 20px;
            font-weight: 400;
            color: #333333;
            width: 278px;
            margin: auto;
            line-height: 36px;
          }
        }
      }
    }
  }
  .fuwu {
    width: 670px;
    margin: auto;
    margin-top: 59px;
    .biaotou {
      ul {
        width: 640px;
        display: flex;
        margin: auto;
        margin-bottom: 10px;
        .li1 {
          width: 37px;
          height: 28px;
          margin-top: 5px;
          img {
            width: 100%;
            height: 1005;
          }
        }
        .li2 {
          margin: 0px 10px;
          p {
            font-size: 30px;
            font-weight: bold;
            color: #333333;
          }
        }
      }
    }
    .xiangxi {
      ul {
        display: flex;
        li {
          width: 335px;
          height: 310px;
          //   background: #ffffff;
          //   box-shadow: 0px 4px 12px 0px rgba(170, 135, 86, 0.2);
          border-radius: 10px;
          margin-top: 20px;
          position: relative;
          padding: 165px 30px 0px 40px;
          box-sizing: border-box;
          .p1 {
            position: absolute;
            top: 114px;
            left: 30px;
            font-size: 20px;
            font-weight: bold;
            color: #ffffff;
          }
          .p2 {
            font-size: 20px;
            font-weight: 400;
            color: #333333;
            line-height: 30px;
          }
        }
        .li1 {
          background: url("../../../assets/images/juzhuanhu/fu-01.png")
            no-repeat center/cover;
          margin-right: 20px;
        }
        .li2 {
          background: url("../../../assets/images/juzhuanhu/fu-02.png")
            no-repeat center/cover;
        }
        .li3 {
          background: url("../../../assets/images/juzhuanhu/fu-03.png")
            no-repeat center/cover;
          margin-right: 20px;
          .p1 {
            position: absolute;
            top: 100px;
            left: 30px;
          }
        }
        .li4 {
          background: url("../../../assets/images/juzhuanhu/fu-04.png")
            no-repeat center/cover;
          .p1 {
            position: absolute;
            top: 100px;
            left: 30px;
          }
          .p2 {
            line-height: 25px;
          }
        }
        .li5 {
          background: url("../../../assets/images/juzhuanhu/fu-05.png")
            no-repeat center/cover;
          margin-right: 20px;
          margin-top: 30px;
          .p1 {
            position: absolute;
            top: 100px;
            left: 30px;
          }
          .p2 {
            line-height: 25px;
          }
        }
        .li6 {
          background: url("../../../assets/images/juzhuanhu/fu-06.png")
            no-repeat center/cover;
          margin-top: 30px;
          .p1 {
            position: absolute;
            top: 100px;
            left: 30px;
          }
          .p2 {
            line-height: 25px;
          }
        }
      }
    }
  }
  .liucheng {
    width: 100%;
    height: 876px;
    margin-top: 60px;
    background: url("../../../assets/images/juzhuanhu/liucheng-01.png")
      no-repeat center/cover;
    padding-top: 116px;
    box-sizing: border-box;
    .buzhou {
      width: 670px;
      margin: auto;
      display: flex;
      .ldian {
        height: 500px;
        width: 24px;
        background: url("../../../assets/images/juzhuanhu/yuan.png") no-repeat
          center/cover;
      }
      .xiangxi {
        margin-left: 30px;
        ul {
          li {
            .p1 {
              font-size: 20px;
              font-weight: bold;
              color: #ffffff;
              margin-bottom: 16px;
            }
            .p2 {
              font-size: 20px;
              font-weight: 400;
              color: #ffffff;
              // margin-bottom: 6px;
            }
          }
        }
      }
    }
  }
  .biaodan {
    width: 100%;
    position: relative;
    .kongbai {
      width: 100%;
      height: 349px;
    }
    .tu {
      width: 100%;
      height: 200px;
      img {
        width: 100%;
        height: 200px;
      }
    }
    .biao {
      width: 750px;
      position: absolute;
      top: 61px;
    }
    .biaoge {
      width: 555px;
      height: 352px;
      background: #ffffff;
      border: 1px solid rgba(170, 135, 86, 0.2);
      box-shadow: 0px 5px 10px 0px rgba(170, 135, 86, 0.2);
      border-radius: 20px;
      margin: auto;
      padding-top: 15px;
      box-sizing: border-box;
      .line {
        width: 220px;
        margin: auto;
        margin-bottom: 20px;
        ul {
          display: flex;
          .li1 {
            width: 37px;
            height: 28px;
            margin-top: 5px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .li2 {
            margin: 0 10px;
            p {
              font-size: 30px;
              font-weight: bold;
              color: #333333;
            }
          }
        }
      }
      .inputis {
        width: 420px;
        margin: auto;
        p {
          font-size: 22px;
          font-weight: 400;
          color: #333333;
          margin-bottom: 10px;
        }
        .inpis {
          background: url("../../../assets/images/red.png") no-repeat 12px;
          background-size: 3% 20%;
          width: 420px;
          height: 50px;
          border: 1px solid #dcb37a;
          border-radius: 10px;
          padding-left: 30px;
          box-sizing: border-box;
          margin-bottom: 17px;
        }
        button:focus {
          outline: 0;
        }
        .btnis {
          width: 140px;
          background: #dcb37a;
          height: 40px;
          border-radius: 20px;
          font-size: 24px;
          font-weight: bold;
          color: #ffffff;
          display: block;
          margin: auto;
        }
      }
    }
  }
}
</style>